module.exports = __webpack_public_path__ + "img/planet2.97edd764.png";